"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import clsx from "clsx";
import Logo from "./Logo";
import { getNavItems, LABELS, ROUTES } from "../../../_lib/routes";
import DesktopContactBtn from "./DesktopContactBtn";

export default function DesktopNavbar() {
	const pathname = usePathname();
	const navItems = getNavItems().filter((item) => item.href !== ROUTES.CONTACT);

	return (
		<div className="hidden sm:flex sm:w-full sm:max-w-[53.125rem] sm:items-center sm:justify-between sm:rounded-lg sm:bg-[#f2f2f2]/50 sm:p-3.5 sm:backdrop-blur-[10px]">
			<Logo />

			<nav className="sm:flex sm:items-center sm:gap-[3.75rem]" aria-label="Main navigation">
				<>
					{navItems.map((item) => {
						const isActive = pathname === item.href;

						return (
							<Link
								key={item.href}
								href={item.href}
								className={clsx(
									"sm:transition-colors sm:duration-200",
									isActive
										? "sm:text-graphite-black sm:text-cap-m-active"
										: "sm:text-graphite-black/50 sm:hover:text-graphite-black sm:text-cap-m",
								)}
							>
								{item.label}
							</Link>
						);
					})}
				</>
			</nav>
			<DesktopContactBtn href={ROUTES.CONTACT} label={LABELS.contact} />
		</div>
	);
}
